import React from 'react';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';
import get from 'lodash/get';
import { useQuoteInfoFromLeadID } from '../../api/api';
import { Loader } from '../components/Loader';
import { salesforceStore } from '../../store/salesforce-store';
import { AppForm } from '../AppForm/AppForm';

export const LeadWrapper = () => {
  const { id } = useParams();
  const { isLoading: isLoadingQuote } = useQuoteInfoFromLeadID(id);
  const formik = useFormikContext();
  if (isLoadingQuote) {
    return <Loader message="Loading your quote..." />;
  }
  if (!get(formik.values, 'Email')) {
    salesforceStore.saveDataToFormik(formik);
  }

  return <AppForm />;
};
